import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BlockContent from '@sanity/block-content-to-react';

const BoxWrapper = styled.div`
  @media screen and (min-width: 1024px) {
    padding: 3rem;
  }
`;

const PortableText = ({ content }) => {
  if (!content) return null;

  const serializers = {
    types: {},
  };

  return (
    <section className="section has-background-light-tan">
      <div className="container">
        <BoxWrapper className="box content">
          <BlockContent blocks={content} serializers={serializers} />
        </BoxWrapper>
      </div>
    </section>
  );
};

export default PortableText;

PortableText.propTypes = {
  content: PropTypes.object.isRequired,
};
